import useCardsOnlyForContext from '@/hooks/cards/useCardsOnlyForContext';
import { createContext } from 'react';

// Context that provides all the cards data functionality
const CardsContext = createContext<ReturnType<typeof useCardsOnlyForContext>>({
	cards: [],
	getCardBySpeciesId: () => null,
	identifyAndStore: () => Promise.reject(undefined),
	storeMedia: () => Promise.reject(),
	getMediaItemExtension: () => 'jpg',
	getMediaItemMimeType: () => 'image/jpeg',
	getMediaItemPath: () => '',
	readPhoto: () => Promise.reject(),
	readAudio: () => Promise.reject(),
	deleteMediaItem: () => Promise.reject(),
});

export default CardsContext;
